module.exports = __webpack_public_path__ + "static/circle-bg-776850e463d00b6e26cd2ccf22f32981.png";